import PropTypes from 'prop-types';

const Series = PropTypes.shape({
	name: PropTypes.string,
	skuCount: PropTypes.number,
});

export default Series;
